import { useAuthenticatedFetch } from './apiService';

export interface AzureVoice {
  Name: string;
  DisplayName: string;
  LocalName: string;
  ShortName: string;
  Gender: string;
  Locale: string;
  SampleRateHertz: string;
  VoiceType: string;
  Status: string;
}

export const useVoiceService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  return {
    fetchVoices: async (): Promise<AzureVoice[]> => {
      const res = await authenticatedFetch('/voices/list');
      if (!res.ok) throw new Error('Failed to load voices');
      return await res.json();
    },
  };
};